import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { log } from 'console';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { PrintMsgBoxComponent } from '../print-msg-box/print-msg-box.component';
import { Observable, Subscriber } from 'rxjs';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-exam-form',
  templateUrl: './exam-form.component.html',
  styleUrls: ['./exam-form.component.scss']
})
export class ExamFormComponent implements OnInit, AfterViewInit {
  examForm: FormGroup;
  addmissionData: any;
  StudentIdd: string;
  SessionNo: any;
  data: any;
  resData: any;
  InstId: any;
  dialogRef: MatDialogRef<any>;
  collegeList: any;
  filteredCollegeList: any;
  ListOfReg: any;
  filteredListOfReg: any;
  Gen = false;
  MultiShId: any = 0;
  isSelectDisabled: boolean = false;
  ShowMsg = false;
  courseStreamList: any;
  Appear = true;
  filteredStreamList: any;
  subDataList: any;
  SubArray: FormArray;
  assignTableData: any[];
  Subjects = [];
  SubCode = [];
  EsID = [];
  HeadSub = [];
  submitpayload: any;
  errMsg: any;
  RgId: any;
  EcId: any;
  FeePaid = false;
  SubTable = false;
  Arr: any;
  StudentPersonalId: string;
  subList: any;
  filteredsubList: any;
  Atddata: any;
  EmId: any;
  Message: string;
  CoCode: any;
  ECID: any;
  SubAtd = false;
  SubMessage = ' ';
  IAatd = false;
  IAMessage = ' ';
  atdstatus = false
  EcIdNew: any;
  RgIdNew: any;
  EfId = 0;
  SaveDisable = false
  resForReport
  collegeCode
  payload: {};
  prefix = '';
  RegnNo = '';
  formattedPrn: any;
  Name: void;
  ReExam: boolean;
  stuName;
  stuCast: any;
  SkipAttendance: boolean;
  fileName: string;
  errormessage: string;
  uploadDoc2: any;
  DocView = false;
  arr: any;
  attendance: any;
  IaAttendance: any;
  MultiEmid: any;
  uploadDoc: any;
  CourseLevel;
  repaterSubjects: any = [];
  count: any = [];
  ShowUGCert: boolean = false;
  optionalSubjects: any[] = [];
  isOptionalStudent: boolean = false;
  studentType: string;
  hiddenOptionalSubjects: any[] = [];
  iaStatus: string = '';
  electiveStatus: boolean = false;
  isIAMarksPassed: boolean = false;
  isElectiveCompleted: boolean = false;
  iaElectiveStatusChecked: boolean = false;
  isIAMarksApplicable: boolean = false;
  isElectiveApplicable: boolean = false;
  isAttendanceApplicable: boolean = false;
  eligibilityPopupShown: boolean = false;
  eligibilityFailed: boolean = false;
  urlSessionNo: string;
  urlEmId: string;
  urlCourseCode: string;
  urlCollegeCode: string;
  urlStudentId: string;

  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient) { }
  studentId = sessionStorage.getItem('StudentRGID');

  ngOnInit(): void {
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.studentId = sessionStorage.getItem('StudentRGID');

    this.Appear = true;
    this.SaveDisable = false;
    this.eligibilityFailed = false;
    this.atdstatus = false
    this.SubAtd = false;
    this.SubMessage = ' ';
    this.IAatd = false;
    this.IAMessage = ' ';
    this.Subjects = []
    this.SubCode = [];
    this.EsID = [];
    this.HeadSub = [];
    this.CoCode = ''
    this.prefix = '';
    this.RegnNo = '';
    this.EfId = 0
    this.FeePaid = false;
    this.Gen = false;
    this.ShowMsg = false;
    this.SubTable = false;
    this.DocView = false;
    this.isIAMarksPassed = false;
    this.isElectiveCompleted = false;
    this.iaElectiveStatusChecked = false;
    this.isIAMarksApplicable = false;
    this.isElectiveApplicable = false;
    this.isAttendanceApplicable = false;
    this.eligibilityPopupShown = false;
    this.examForm = this.fb.group({
      SValid: new FormControl(''),
      SApp: new FormControl(''),
      SChng: new FormControl(''),
      RegnNo: new FormControl(''),
      Colg: new FormControl(''),
      Branch: new FormControl(''),
      Name: new FormControl(''),
      Cate: new FormControl(''),
      Center: new FormControl(''),
      Valid: new FormControl(''),
      Valid1: new FormControl(''),
      List: new FormControl(''),
      College: new FormControl(''),
      EsType: new FormControl(''),
      SrNo: new FormControl(''),
      EsId: new FormControl(''),
      Head: new FormControl(''),
      Marks: new FormControl(''),
      NewSub: new FormControl(''),
      Sub: new FormControl(''),
      EsName: new FormControl(''),
      App: new FormControl('Y'),
      Atnd: new FormControl(''),
      CultDress: new FormControl('', Validators.required),
      LogBook: new FormControl(''),
      OtherUni: new FormControl(''),
      UGDocFile: new FormControl(''),
      DocumentFile: new FormControl(''),
      PosterPresent: new FormControl(''),
      PodiumPresent: new FormControl(''),
      PublishPaper: new FormControl(''),
      GCPGCLP: new FormControl(''),
      ResearchMethodology: new FormControl(''),
      BCLSACLS: new FormControl(''),
      elogbook: new FormControl(''),
      DRPlogbook: new FormControl(''),
      NationalSeminarCert: new FormControl(''),
      AyurvedUndertaking: new FormControl(''),
      SubArray: new FormArray([]),
      arrData: this.fb.array([]),
    });

    this.route.queryParams.subscribe(params => {
      console.log('ExamForm Query Params:', params);

      // Store URL parameters
      this.urlEmId = params['emid'] || '0';
      this.urlCourseCode = params['courseCode'] || sessionStorage.getItem("StuCoId");
      this.urlCollegeCode = params['collegeCode'] || sessionStorage.getItem("StuCgId");
      this.urlSessionNo = params['sessionNo'] || sessionStorage.getItem('session');
      this.urlStudentId = params['studentId'] || params['StuId'] || sessionStorage.getItem('StudentPersonalId');

      this.MultiEmid = +this.urlEmId ? +this.urlEmId : 0;

      // Override StudentPersonalId with URL parameter if provided
      if (this.urlStudentId) {
        this.StudentPersonalId = this.urlStudentId;
        sessionStorage.setItem('StudentPersonalId', this.urlStudentId);
      }

      // Override session in sessionStorage with URL parameter
      if (this.urlSessionNo) {
        this.SessionNo = this.urlSessionNo;
        sessionStorage.setItem('session', this.urlSessionNo);
      }

      if (params['rgNo']) {
        this.studentId = params['rgNo'];
        sessionStorage.setItem('StudentRGID', this.studentId);
      }

      if (this.urlEmId) {
        sessionStorage.setItem('StuEmId', this.urlEmId);
      }

      console.log('Using Session from URL:', this.urlSessionNo);
      console.log('Using EmId from URL:', this.urlEmId);
      console.log('Using StudentId from URL:', this.urlStudentId);

      this.initializeComponent();
    });
  }
  private initializeComponent(): void {
    this.addNew();
    this.getCollege();
    this.getScretData();
    this.prepopulation();
    this.getAppliTracker();
    this.searchValid();
  }

  getStudentIAElectiveStatus() {
    if (!this.EmId || !this.SessionNo || !this.StudentPersonalId) {
      console.warn('IA/Elective status: missing required params');
      return;
    }
    this.spinner.show();
    const payload = {
      EmId: this.EmId,
      SessionID: this.SessionNo,
      StuId: parseInt(this.StudentPersonalId)
    };
    this.umsService.getStudentIAElectiveStatus(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status && res.formSetting) {
          this.isAttendanceApplicable = res.formSetting.IsAttendance || false;
          this.isIAMarksApplicable = res.formSetting.IsIaMarks || false;
          this.isElectiveApplicable = res.formSetting.IsElective || false;
          if (res.statusData) {
            this.iaStatus = res.statusData.IAStatus || 'N';
            this.electiveStatus = res.statusData.ElectiveStatus === true ? true : false;
          } else {
            this.iaStatus = 'N';
            this.electiveStatus = false;
          }
          this.isIAMarksPassed = this.isIAMarksApplicable ? (this.iaStatus === 'Y') : true;
          this.isElectiveCompleted = this.isElectiveApplicable ? this.electiveStatus : true;

          this.iaElectiveStatusChecked = true;
          console.log('IA applicable:', this.isIAMarksApplicable, 'IA Status:', this.iaStatus, 'Passed:', this.isIAMarksPassed);
          console.log('Elective applicable:', this.isElectiveApplicable, 'Elective Status:', this.electiveStatus, 'Completed:', this.isElectiveCompleted);
        }
        else if (res.status && res.data && res.data.length > 0) {
          const result = res.data[0];
          this.isIAMarksApplicable = true;
          this.isElectiveApplicable = true;
          this.iaStatus = result.IAStatus || 'N';
          this.electiveStatus = result.ElectiveStatus === 1 ? true : false;
          this.isIAMarksPassed = (this.iaStatus === 'Y');
          this.isElectiveCompleted = this.electiveStatus;
          this.iaElectiveStatusChecked = true;
          console.log('IA Status (from data):', this.iaStatus, 'Elective Status:', this.electiveStatus);
        }
        else {
          this.isIAMarksApplicable = false;
          this.isElectiveApplicable = false;
          this.iaStatus = 'N';
          this.electiveStatus = false;
          this.isIAMarksPassed = false;
          this.isElectiveCompleted = false;
          this.iaElectiveStatusChecked = true;
        }
      },
      (error) => {
        this.spinner.hide();
        console.error('Error fetching IA/Elective status:', error);
        this.isIAMarksApplicable = false;
        this.isElectiveApplicable = false;
        this.iaStatus = 'N';
        this.electiveStatus = false;
        this.isIAMarksPassed = false;
        this.isElectiveCompleted = false;
        this.iaElectiveStatusChecked = true;
      }
    );
  }

  computeSaveDisable() {
    this.SaveDisable = this.eligibilityFailed;
    console.log('SaveDisable computed:', this.SaveDisable, 'eligibilityFailed:', this.eligibilityFailed);
  }

  showEligibilityPopup() {
    let messages = [];

    if (this.isIAMarksApplicable && !this.isIAMarksPassed) {
      messages.push('IA marks not cleared');
    }

    if (this.isElectiveApplicable && !this.isElectiveCompleted) {
      messages.push('Elective subjects not cleared');
    }

    if (messages.length === 0) {
      messages.push('Eligibility conditions not met');
    }

    const data = {
      message: 'You are not eligible to submit the exam form due to: ' + messages.join(', '),
      title: 'Eligibility Check',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }

  checkSave(RgId) {
    this.umsService.fetchLatestEcid({ RgId: RgId, CoCode: sessionStorage.getItem("StuCoId") })
      .subscribe((res) => {
        if (res.status) {
          let payload = {};
          payload['EcShId'] = this.MultiShId;
          payload['EcInCode'] = " ";
          payload['EcOpId'] = 0;
          this.umsService.getSupExamEditRecord(payload).subscribe(
            (res) => {
              if (res.status) {
                this.spinner.hide();
                const ExmForm = res.data.filter(record => record.EcInCode == 19);
                if (ExmForm.length > 0) {
                  if (ExmForm[0]['EcStatus'] == 'U') {
                    this.SaveDisable = true
                  }
                  else if (ExmForm[0]['EcStatus'] == 'O') {
                    this.SaveDisable = false
                  }
                }
                this.getStudentIAElectiveStatus();
              }
            });
        }
      });
  }

  ngAfterViewInit() {

  }

  addNew() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.push(
      this.fb.group({
        DocumentName: new FormControl('Attendance Certificate Of Research Methodology Workshop'),
        DocumentFile: new FormControl(''),
        docFile: new FormControl(''),
      })
    );
  }

  addNewDoc() {
    const creds = this.examForm.controls.arrData as FormArray;

    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'UG Degree Certificate Of Other University';
    });

    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('UG Degree Certificate Of Other University'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeDoc() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'UG Degree Certificate Of Other University') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  getSubArrayControls() {
    return (this.examForm.get('SubArray') as FormArray).controls;
  }

  addNewRow() {
    const creds = this.examForm.controls.SubArray as FormArray;
    creds.push(
      this.fb.group({
        EsType: new FormControl(''),
        SrNo: new FormControl(''),
        EsParent: new FormControl(''),
        EsId: new FormControl(''),
        Head: new FormControl(''),
        Marks: new FormControl(''),
        NewSub: new FormControl(''),
        Sub: new FormControl(''),
        EsName: new FormControl(''),
        App: new FormControl('Y'),
        Atnd: new FormControl(''),
      })
    );
  }

  getCollege() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.spinner.hide();
      }
      else {
        this.collegeList = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  prepopulation() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.stuName = res.data[0]['StudentName']
        this.examForm.controls['RegnNo'].setValue(res.data[0]['StuRgNo']);
        this.examForm.controls['Name'].setValue(this.stuName);
        this.spinner.show()
        let payload1 = {};
        payload1['StuId'] = this.StudentPersonalId;
        this.umsService.fetchReservationDetails(payload1).subscribe((res) => {
          if (res.status) {
            this.spinner.hide()
            this.fetchSocialReservation(res.data[0]['StuConstiSubCate'])
          }
          else {
            this.spinner.hide()
          }
        }, (ERROR: HttpErrorResponse) => {
          this.collegeList = [];
          this.spinner.hide();
        })
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  checkSession(SnNo) {
    this.spinner.show()
    const payload = {};
    payload['SnNo'] = SnNo;
    this.umsService.getSession(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0]['SnName'].includes('Re')) {
          this.ReExam = true;
        }
        else {
          this.ReExam = false;
        }
        this.spinner.hide()
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getScretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if (arrActiveFlow[0]['SkipAttendance'] == 1) {
          this.SkipAttendance = true;
        }
        else if (arrActiveFlow[0]['SkipAttendance'] == 0) {
          this.SkipAttendance = false;
        }
        this.spinner.hide()
        this.SessionNo = this.urlSessionNo || res.projectPharam['SnNo'];
        this.InstId = res.projectPharam['ClubPartTrans'];
        this.checkSession(this.SessionNo);
        this.prepopulationOfAddmission(this.SessionNo);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchSocialReservation(caste) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        res.data.filter(item => {
          if (item.CdCode == caste) {
            this.stuCast = item.CdDesc
          }
        })
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  prepopulationOfAddmission(SnNo) {
    this.spinner.show()
    this.CoCode = '';
    this.StudentIdd = this.StudentPersonalId || sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.addmissionData = res.data[0];
        this.examForm.controls['Colg'].setValue(this.addmissionData['StuCgId']);
        this.examForm.controls['College'].setValue(this.addmissionData['StuCgId']);
        this.examForm.controls['Cate'].setValue(this.addmissionData['StuSpecialCate']);
        const emId = this.urlEmId || res.data[0]['StuEmId'];
        this.searchExamForm(res.data[0]['StuCgId'], res.data[0]['StuCoId'], SnNo, res.data[0]['StuBrId'], emId)
        this.CoCode = res.data[0]['StuCoId'];
        this.getExamStreamData(res.data[0]['StuCoId'], res.data[0]['StuBrId'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getExamStreamData(id, branch) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.examForm.controls['Branch'].setValue(parseInt(branch));
      }
      else {
        this.spinner.hide()
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  searchExamForm(CgCode, CoCode, SnNo, branch, EmId) {
    this.spinner.show()
    this.EmId = 0;
    const payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.RgId = res.data[0]['RgId'];
        this.checkSave(res.data[0]['RgId'])
        this.GetEcId(res.data[0]['RgId'], CgCode, CoCode, SnNo, branch, EmId);
      }
      else {
        this.spinner.hide()
        this.getstuSubject();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  searchExams(RgId, CgCode, CoCode, SnNo, branch, EmId) {
    this.spinner.show()
    let payload = {};
    this.EfId = 0;
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      this.resForReport = res.data[0];
      this.EfId = res.data[0]['EfId'];
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.spinner.hide()
          this.EmId = res.data[0]['EmId']
          this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId, branch, res.data[0]['EcId'], RgId)

        }
        else {
          this.spinner.hide()
          this.EmId = res.data[0]['EmId']
          this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId, branch, res.data[0]['EcId'], RgId)
        }
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  GetEcId(RgId, CgCode, CoCode, SnNo, branch, EmId) {
    this.spinner.show()
    let payload = {};
    this.EfId = 0;
    payload['RgId'] = RgId;
    payload['EmId'] = this.MultiEmid || this.urlEmId || EmId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    payload['SnNo'] = this.SessionNo || SnNo;
    this.umsService.GetEcId(payload).subscribe((res) => {
      this.resForReport = res.data[0];
      this.EfId = res.data[0]['EfId'];
      this.MultiShId = res.data[0].ShId;
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.spinner.hide()
          this.EmId = res.data[0]['EmId']
          this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId, branch, res.data[0]['EcId'], RgId)
        }
        else {
          this.spinner.hide()
          this.EmId = res.data[0]['EmId']
          this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId, branch, res.data[0]['EcId'], RgId)
        }
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  NewValidate(data) {
    this.spinner.show()
    let payload = {};
    payload['EcId'] = data.EcId;
    payload['ForRgId'] = this.RgId;
    payload['ForSrNo'] = 0;
    payload['Inst'] = data.Inst;
    payload['LoginId'] = data.LoginId;
    this.umsService.NewvalidateGenExams(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      }
      else {
        this.spinner.hide()
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  ExmFrmEditListCo(CgCode, CoCode, SnNo, EmId, branch, ecid, rgid) {
    this.spinner.show()
    this.payload = []
    this.spinner.show();
    this.RgIdNew = 0;
    this.EcIdNew = 0
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = 19;
    payload['EmId'] = this.MultiEmid || this.urlEmId || EmId;
    this.umsService.ExmFrmEditListCo(payload).subscribe((res) => {
      if (res.status) {
        this.data = res.data[0];
        this.examForm.controls['List'].setValue(this.data['EcId']);
        this.ListOfReg = res.data;
        this.filteredListOfReg = this.ListOfReg.slice();
        this.Gen = true;
        this.ShowMsg = false;
        const promises: Promise<void>[] = [];
        const promise1 = new Promise<void>((resolve, reject) => {
          let payload = {};
          payload['LoginId'] = this.data['EcOpId'];
          payload['EmId'] = this.data['EmId'];
          payload['CgCode'] = CgCode;
          payload['Branch'] = '';
          payload['Cate'] = 'A';
          payload['RgNo'] = this.studentId;
          payload['ForSnNo'] = "";
          payload['SoftCopy'] = "";
          payload['EcId'] = this.data['EcId'];
          payload['Inst'] = this.InstId;
          payload['StuId'] = this.addmissionData['StuId'];
          this.payload = payload
          let formNotOpen = {
            RgId: rgid,
            EmId: EmId,
            EcId: ecid,
            StuId: this.addmissionData['StuId']
          }

          this.umsService.FormNotOpen(formNotOpen).subscribe((res) => {
            if (res.status) {
              this.umsService.ExmFormSub(formNotOpen).subscribe((res) => {
                if (res.data.length === 0) {
                  this.umsService.GenExmForm(payload).subscribe((res) => {
                    if (res.status) {
                      if (res.message == "No new form generated") {
                        this.spinner.hide()
                      }
                      else if (res.message != "No new form generated") {
                        this.spinner.hide()
                      }

                    }
                    resolve();
                  })
                }
                else {
                  this.spinner.hide()
                  resolve();
                }
              })
            }
          })

        });
        const promise2 = new Promise<void>((resolve, reject) => {
          let payload = {};
          payload['StuRgNo'] = this.studentId;
          this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
            if (res.status) {
              this.spinner.hide()
              this.examForm.controls['Name'].setValue(res.data[0]['StuFullNameEng']);
              this.examForm.controls['RegnNo'].setValue(res.data[0]['StuRgNo']);
              this.getCourse()
            }
            else {
              this.spinner.hide()
            }
            resolve();
          })
        });

        promises.push(promise1);
        promises.push(promise2);

        Promise.all(promises).then(() => {
          this.spinner.hide()
          this.ExmFormSub(ecid, rgid);
          this.EcIdNew = ecid
          this.RgIdNew = rgid

        });
      }
      else {
        const payload = {};
        payload['RgNo'] = sessionStorage.getItem('StudentRGID');
        payload['SnNo'] = parseInt(this.SessionNo)
        this.umsService.GetStuSubject(payload).subscribe((res) => {
          if (res.status) {
            this.spinner.hide();
            this.personalDetail()
              // this.assignTableData = res.data;
            // this.SubTable = true;
            // this.SubArray = this.examForm.get('SubArray') as FormArray;
            // this.assignTableData.forEach((element, i) => {
            //   const showDropdown = !element.Head;
            //   const showYN = element.EsOpCode
            //   this.isSelectDisabled = !showYN;
            //   const creds = this.examForm.controls.SubArray as FormArray;
            //   creds.push(
            //     this.fb.group({
            //       EsType: new FormControl(element.EsType),
            //       SrNo: new FormControl(1),
            //       EsId: new FormControl(element.SEsId),
            //       EsParent: new FormControl(element.EsParent),
            //       Head: new FormControl(element.Head),
            //       Marks: new FormControl(element.Marks),
            //       NewSub: new FormControl(element.NewSub),
            //       Sub: new FormControl(element.Sub),
            //       EsName: new FormControl(element.EsName),
            //       Pass: new FormControl(''),
            //       App: new FormControl(element.App),
            //       showDropdown: new FormControl(showDropdown),
            //       showYN: new FormControl(showYN)
            //     })

            //   );
            //   let x = (this.examForm.get('SubArray') as FormArray).controls;
            //   x.forEach(element => {
            //     element['controls']['App'].setValue('Y');
            //   });

            // });
            this.assignTableData = res.data;
            this.SubTable = true;
            this.SubArray = this.examForm.get('SubArray') as FormArray;

            const groupedData = new Map<number, any[]>();

            this.assignTableData.forEach((element) => {
              if (element.EsType === 'S') {
                groupedData.set(element.SEsId, [element]);
              } else if (element.EsType === 'P') {
                if (!groupedData.has(element.EsParent)) {
                  groupedData.set(element.EsParent, []);
                }
                groupedData.get(element.EsParent)?.push(element);
              }
            });

            const sortedData: any[] = [];

            groupedData.forEach((subjects) => {
              sortedData.push(...subjects);
            });

            const creds = this.examForm.controls.SubArray as FormArray;
            sortedData.forEach((element, i) => {
              const showDropdown = !element.Head;
              const showYN = element.EsOpCode;

              creds.push(
                this.fb.group({
                  EsType: new FormControl(element.EsType),
                  SrNo: new FormControl(i + 1),
                  EsId: new FormControl(element.SEsId),
                  EsParent: new FormControl(element.EsParent),
                  Head: new FormControl(element.Head),
                  Marks: new FormControl(element.Marks),
                  NewSub: new FormControl(element.NewSub),
                  Sub: new FormControl(element.Sub),
                  EsName: new FormControl(element.EsName),
                  Pass: new FormControl(''),
                  App: new FormControl(element.App),
                  showDropdown: new FormControl(showDropdown),
                  showYN: new FormControl(showYN),
                  Atnd: new FormControl('')
                })
              );
            });

            (this.examForm.get('SubArray') as FormArray).controls.forEach((element) => {
              element['controls']['App'].setValue('Y');
            });
            this.fetchStudentAttd(ecid, rgid);
            const attendanceMap = new Map<number, number>();
            this.attendance?.forEach((item) => {
              attendanceMap.set(item.EsId, item.AttendCount);
            });
            this.IaAttendance?.forEach((item) => {
              attendanceMap.set(item.EsId, item.AttendCount);
            });
            creds.value.forEach((item) => {
              if (attendanceMap.has(item.EsId)) {
                item.Atnd = attendanceMap.get(item.EsId);
              }
            });

            this.Gen = false;
            this.ShowMsg = true;
            this.Message = 'This Exam Form Is Already Generated'
          }
          else {
            this.spinner.hide();
            this.Gen = false;
            this.ShowMsg = false;
            this.assignTableData = []
            this.SubTable = false;
          }

        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
    this.getExamForm(ecid, rgid)
  }

  isVisible(subData: FormArray): boolean {
    const esTypeToShow = 'S';
    return subData.get('EsType').value === esTypeToShow;
  }

  getFeeTempData(CgCode, CoCode, SnNo, payload1) {
    this.spinner.show();
    this.collegeCode = CgCode
    this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = SnNo,
      payload['CoCode'] = CoCode
    payload['CgCode'] = CgCode
    payload['StuId'] = this.StudentIdd;
    payload['FeeType'] = 'EF';
    this.umsService.fetchFeeTemp(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd, payload1)
      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.NewValidate(payload1);
          this.FeePaid = false;
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  SearchFeeDetails(TempCode, StdId, payload1) {
    this.spinner.show();
    const payload = {};
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });

        if (data == res.data[0]['TotalPaidAmount']) {
          // this.ExmFrmEditListCo(EmId, SnNo)
          // this.validateGeneratedExams(payload1)
          this.FeePaid = true;
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          this.NewValidate(payload1);
          this.FeePaid = false;
        }
      } else {
        this.NewValidate(payload1);
        this.FeePaid = false;
      }
    });
  }

  validateGeneratedExams(data) {
    this.spinner.show()
    let payload = {};
    payload['EcId'] = data.EcId;
    payload['ForRgId'] = this.RgId;
    payload['ForSrNo'] = 0;
    payload['Inst'] = data.Inst;
    payload['LoginId'] = data.LoginId;
    this.umsService.PutvalidateGeneratedExams(payload).subscribe((res) => {
      if (res.status) {
        this.saveApplicationDetails()
      }
      else {
        this.spinner.hide();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      });
  }

  saveApplicationDetails() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] = this.SessionNo;
    payload['CgCode'] = this.collegeCode;
    payload['CoCode'] = this.CoCode;
    payload['ApplicationName'] = 'Exam Form'
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  personalDetail() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.examForm.controls['Name'].setValue(res.data[0]['StuFullNameEng']);
        this.examForm.controls['RegnNo'].setValue(res.data[0]['StuRgNo']);
        this.getCourse();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
  // ExmFormSub(EcId, RgId) {
  //   this.spinner.show();
  //   const payload = {};
  //   payload['EcId'] = EcId;
  //   payload['RgId'] = RgId;
  //   this.umsService.ExmFormSub(payload).subscribe((res) => {
  //     // this.spinner.hide();
  //     if (res.status) {
  //       this.umsService.ExmFormReapter(payload).subscribe((res1) => {
  //         if (res1.status) {
  //           this.repaterSubjects = res1.data.filter((it) => it.EmId === this.MultiEmid);
  //           this.count = res1.count;
  //           this.studentType = (this.repaterSubjects.length > 0) ? 'R' : 'N';
  //           this.spinner.hide()
  //           this.Gen = true;
  //           // this.assignTableData = res.data;
  //           // this.SubTable = true;
  //           // this.SubArray = this.examForm.get('SubArray') as FormArray;
  //           // this.assignTableData.forEach((element, i) => {
  //           //   const showDropdown = !element.Head;
  //           //   const showYN = element.EsOpCode
  //           //   const creds = this.examForm.controls.SubArray as FormArray;
  //           //   creds.push(
  //           //     this.fb.group({
  //           //       EsType: new FormControl(element.EsType),
  //           //       SrNo: new FormControl(1),
  //           //       EsId: new FormControl(element.SEsId),
  //           //       EsParent: new FormControl(element.EsParent),
  //           //       Head: new FormControl(element.Head),
  //           //       Marks: new FormControl(element.Marks),
  //           //       NewSub: new FormControl(element.NewSub),
  //           //       Sub: new FormControl(element.Sub),
  //           //       EsName: new FormControl(element.EsName),
  //           //       Pass: new FormControl(''),
  //           //       App: new FormControl(element.App),
  //           //       showDropdown: new FormControl(showDropdown),
  //           //       showYN: new FormControl(showYN)
  //           //     })
  //           //   );
  //           //   let x = (this.examForm.get('SubArray') as FormArray).controls;
  //           //   x.forEach(element => {
  //           //     element['controls']['App'].setValue('Y');
  //           //   });

  //           // });
  //           if (this.repaterSubjects.length > 0 && this.count.EmId == this.MultiEmid) {
  //             this.assignTableData = res.data.filter(it =>
  //               this.repaterSubjects.some(rs => rs.EsId === it.SEsId || rs.EsId === it.EsParent)
  //             );
  //           }
  //           else {
  //             this.assignTableData = res.data;
  //           }

  //           this.SubTable = true;
  //           this.SubArray = this.examForm.get('SubArray') as FormArray;

  //           // Step 1: Group subjects by their ID for quick lookup
  //           const groupedData = new Map<number, any[]>();

  //           this.assignTableData.forEach((element) => {
  //             if (element.EsType === 'S') {
  //               groupedData.set(element.SEsId, [element]); // Store main subject
  //             } else if (element.EsType === 'P') {
  //               // If parent exists, push the component subject under it
  //               if (!groupedData.has(element.EsParent)) {
  //                 groupedData.set(element.EsParent, []);
  //               }
  //               groupedData.get(element.EsParent)?.push(element);
  //             }
  //           });

  //           // Step 2: Flatten the grouped data into a single ordered array
  //           const sortedData: any[] = [];

  //           groupedData.forEach((subjects) => {
  //             sortedData.push(...subjects);
  //           });

  //           // Step 3: Populate the FormArray
  //           const creds = this.examForm.controls.SubArray as FormArray;
  //           sortedData.forEach((element, i) => {
  //             const showDropdown = !element.Head;
  //             const showYN = element.EsOpCode;

  //             creds.push(
  //               this.fb.group({
  //                 EsType: new FormControl(element.EsType),
  //                 SrNo: new FormControl(i + 1),
  //                 EsId: new FormControl(element.SEsId),
  //                 EsParent: new FormControl(element.EsParent),
  //                 Head: new FormControl(element.Head),
  //                 Marks: new FormControl(element.Marks),
  //                 NewSub: new FormControl(element.NewSub),
  //                 Sub: new FormControl(element.Sub),
  //                 EsName: new FormControl(element.EsName),
  //                 Pass: new FormControl(''),
  //                 App: new FormControl(element.App),
  //                 showDropdown: new FormControl(showDropdown),
  //                 showYN: new FormControl(showYN),
  //                 Atnd: new FormControl('')
  //               })
  //             );
  //           });

  //           // Step 4: Set 'App' value for all items in the FormArray
  //           (this.examForm.get('SubArray') as FormArray).controls.forEach((element) => {
  //             element['controls']['App'].setValue('Y');
  //           });


  //           this.fetchStudentAttd(EcId, RgId);
  //           this.fetchStudentIAAtd();
  //         }
  //       })
  //     }
  //     else {
  //       this.spinner.hide()
  //       this.Gen = false;
  //       this.assignTableData = []
  //       this.SubTable = false;
  //       this.SubArray = this.examForm.get('SubArray') as FormArray;
  //       this.SubArray.push(
  //         this.fb.group({
  //           EsType: new FormControl(''),
  //           SrNo: new FormControl(''),
  //           EsId: new FormControl(''),
  //           Head: new FormControl(''),
  //           Marks: new FormControl(''),
  //           NewSub: new FormControl(''),
  //           Sub: new FormControl(''),
  //           EsName: new FormControl(''),
  //           Pass: new FormControl(''),
  //           App: new FormControl('Y'),
  //           Atnd: new FormControl(''),
  //           EsParent: new FormControl(''),
  //         })
  //       );
  //     }

  //   }, (ERROR: HttpErrorResponse) => {
  //     this.spinner.hide();
  //     this.subDataList = []
  //   })
  // }

  ExmFormSub(EcId, RgId) {
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    console.log('=== ExmFormSub called ===');
    console.log('EcId:', EcId, 'RgId:', RgId);
    
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      console.log('Main ExmFormSub API response status:', res.status);
      
      if (res.status) {
        console.log('Main subject list (res.data):', res.data);
        console.log('Total subjects count:', res.data.length);
        
        this.umsService.ExmFormReapter(payload).subscribe((res1) => {
          let repeaterData = [];
          let repeaterCount = null;
          if (res1.status) {
            repeaterData = res1.data.filter((it) => it.EmId === this.MultiEmid);
            repeaterCount = res1.count;
            this.studentType = (repeaterData.length > 0) ? 'R' : 'N';
            
            console.log('Repeater API response:', res1);
            console.log('Filtered repeaterData (for EmId', this.MultiEmid, '):', repeaterData);
            console.log('studentType:', this.studentType);
          }

          const optPayload = { RgId: this.RgId, EcId: EcId };
          this.umsService.getOptionalSubjects(optPayload).subscribe((optRes) => {
            let selectedOptionalIds = [];
            let hiddenOptionalIds = [];
            
            console.log('Optional API response:', optRes);
            
            if (optRes.status) {
              selectedOptionalIds = optRes.data.map(opt => opt.EsId);
              hiddenOptionalIds = optRes.hiddenSubjects ? optRes.hiddenSubjects.map(opt => opt.EsId) : [];
              this.isOptionalStudent = (optRes.count?.RepSubCount > 0);
              this.hiddenOptionalSubjects = optRes.hiddenSubjects || [];
              
              console.log('Selected optional subjects (optRes.data):', optRes.data);
              console.log('Selected optional IDs:', selectedOptionalIds);
              console.log('Hidden/unselected subjects (optRes.hiddenSubjects):', optRes.hiddenSubjects);
              console.log('Hidden optional IDs:', hiddenOptionalIds);
              console.log('isOptionalStudent:', this.isOptionalStudent);
            }

            let filteredSubjects = res.data;
            console.log('Initial filteredSubjects (all subjects):', filteredSubjects.map(s => ({ SEsId: s.SEsId, EsName: s.EsName })));

            if (hiddenOptionalIds.length > 0) {
              filteredSubjects = filteredSubjects.filter(subject =>
                !hiddenOptionalIds.includes(subject.SEsId)
              );
              console.log('After hiding unselected optional subjects, filteredSubjects count:', filteredSubjects.length);
              console.log('Filtered subjects (after hiding):', filteredSubjects.map(s => ({ SEsId: s.SEsId, EsName: s.EsName })));
            } else {
              console.log('No hidden optional subjects, no filtering applied.');
            }

            if (this.studentType === 'R' && repeaterData.length > 0 && repeaterCount?.EmId == this.MultiEmid) {
              const beforeRepeaterFilterCount = filteredSubjects.length;
              filteredSubjects = filteredSubjects.filter(it =>
                repeaterData.some(rs => rs.EsId === it.SEsId || rs.EsId === it.EsParent)
              );
              console.log('Repeater filter applied. Before filter count:', beforeRepeaterFilterCount, 'After filter count:', filteredSubjects.length);
              console.log('Filtered subjects after repeater filter:', filteredSubjects.map(s => ({ SEsId: s.SEsId, EsName: s.EsName })));
            } else {
              console.log('Not a repeater student (or no repeater data), skipping repeater filter.');
            }

            console.log('Final filteredSubjects being sent to populateSubjectFormArray:', filteredSubjects);
            
            this.spinner.hide();
            this.Gen = true;
            this.populateSubjectFormArray(filteredSubjects);

          }, (err) => {
            console.error('Optional API failed:', err);
            let filteredSubjects = res.data;
            if (this.studentType === 'R' && repeaterData.length > 0 && repeaterCount?.EmId == this.MultiEmid) {
              filteredSubjects = res.data.filter(it =>
                repeaterData.some(rs => rs.EsId === it.SEsId || rs.EsId === it.EsParent)
              );
              console.log('Fallback: Applied repeater filter after optional API error. Filtered count:', filteredSubjects.length);
            }
            this.spinner.hide();
            this.Gen = true;
            this.populateSubjectFormArray(filteredSubjects);
          });
        });
      }
      else {
        console.warn('ExmFormSub API returned status false:', res);
        this.spinner.hide()
        this.Gen = false;
        this.assignTableData = []
        this.SubTable = false;
        this.SubArray = this.examForm.get('SubArray') as FormArray;
        this.SubArray.push(
          this.fb.group({
            EsType: new FormControl(''),
            SrNo: new FormControl(''),
            EsId: new FormControl(''),
            Head: new FormControl(''),
            Marks: new FormControl(''),
            NewSub: new FormControl(''),
            Sub: new FormControl(''),
            EsName: new FormControl(''),
            Pass: new FormControl(''),
            App: new FormControl('Y'),
            Atnd: new FormControl(''),
            EsParent: new FormControl(''),
          })
        );
      }

    }, (ERROR: HttpErrorResponse) => {
      console.error('ExmFormSub HTTP error:', ERROR);
      this.spinner.hide();
      this.subDataList = []
    });
  }
    
  populateSubjectFormArray(rawSubjects: any[]) {
    this.assignTableData = rawSubjects;
    this.SubTable = true;
    this.SubArray = this.examForm.get('SubArray') as FormArray;

    while (this.SubArray.length) {
      this.SubArray.removeAt(0);
    }
    const groupedData = new Map<number, any[]>();

    this.assignTableData.forEach((element) => {
      if (element.EsType === 'S') {
        groupedData.set(element.SEsId, [element]);
      } else if (element.EsType === 'P') {
        if (!groupedData.has(element.EsParent)) {
          groupedData.set(element.EsParent, []);
        }
        groupedData.get(element.EsParent)?.push(element);
      }
    });

    const sortedData: any[] = [];

    groupedData.forEach((subjects) => {
      sortedData.push(...subjects);
    });

    const creds = this.SubArray;
    sortedData.forEach((element, i) => {
      const showDropdown = !element.Head;
      const showYN = element.EsOpCode;

      creds.push(
        this.fb.group({
          EsType: new FormControl(element.EsType),
          SrNo: new FormControl(i + 1),
          EsId: new FormControl(element.SEsId),
          EsParent: new FormControl(element.EsParent),
          Head: new FormControl(element.Head),
          Marks: new FormControl(element.Marks),
          NewSub: new FormControl(element.NewSub),
          Sub: new FormControl(element.Sub),
          EsName: new FormControl(element.EsName),
          Pass: new FormControl(''),
          App: new FormControl(element.App),
          showDropdown: new FormControl(showDropdown),
          showYN: new FormControl(showYN),
          Atnd: new FormControl('')
        })
      );
    });

    (this.examForm.get('SubArray') as FormArray).controls.forEach((element) => {
      element['controls']['App'].setValue('Y');
    });

    this.fetchStudentAttd(this.EcIdNew, this.RgIdNew);
    this.fetchStudentIAAtd();
  }

  getstuSubject() {
    this.spinner.show()
    const payload = {};
    payload['RgNo'] = this.studentId;
    this.umsService.getStuSubject(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.subList = res.data;
        this.filteredsubList = this.subList.slice();
      } else {
        this.spinner.hide()
        this.subList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  // isAttendanceDeficient(subData): boolean {
  //   // Check both conditions, replace with actual condition for fees
  //   let value = false
  //   let SubjectCode = subData.get('EsId').value

  //   this.EsID.forEach(element => {
  //     if (element === SubjectCode) {
  //       value = true;
  //     }
  //   });
  //   return value

  // }

  isAttendanceDeficient(subData: AbstractControl): boolean {
  const esId = subData.get('EsId')?.value;
  if (!esId) return false;
  const sessionId = Number(this.SessionNo);
  const subjectId = Number(esId);

  const theoryDeficient = this.attendance?.some(item =>
    Number(item.EsId) === subjectId &&
    Number(item.SessionID) === sessionId &&
    item.AttendStatus === 'N'
  );
  const iaDeficient = this.IaAttendance?.some(item =>
    Number(item.EsId) === subjectId &&
    Number(item.SessionID) === sessionId &&
    item.AttendStatus === 'N'
  );
  return (theoryDeficient || iaDeficient) || false;
}

  Generate() {
    let array = this.examForm.controls.SubArray as FormArray;
    let payload = array.value;
    let isAnyControlTouched = false;
    payload.forEach((element, index) => {
      if (element.EsType == 'P' && element.App == ' ') {
        array.controls[index].get('App').setErrors({ mandatory: true });
        array.controls[index].get('App').markAsTouched();
        isAnyControlTouched = true;
      } else if (element.EsType == 'P' && element.App != ' ') {
        array.controls[index].get('App').setErrors(null);
      }
    });
    console.log('isAnyControlTouched', isAnyControlTouched);

    if (isAnyControlTouched == false) {
      this.submitExamForm()
    }
  }

  submitExamForm() {
    let eligible = true;
    let messages = [];

    if (this.isIAMarksApplicable && !this.isIAMarksPassed) {
      eligible = false;
      messages.push('IA marks not cleared');
    }
    if (this.isElectiveApplicable && !this.isElectiveCompleted) {
      eligible = false;
      messages.push('Elective subjects not cleared');
    }

    if (!eligible) {
      const data = {
        message: 'You are not eligible to submit the exam form due to: ' + messages.join(', '),
        title: 'Eligibility Check',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.eligibilityFailed = true;
        this.computeSaveDisable();
      });
      return;
    }

    this.SubArray = this.examForm.get('SubArray') as FormArray;
    let isPopupShown = false;
    let isAnyControlTouched = false;
    const subjectsToAlert: string[] = [];
    const HeadId = [];
    this.SubArray.value.forEach(element => {
      if (element.App === 'N') {
        if (element.EsType === 'P') {
          HeadId.push(element.EsParent)
          isAnyControlTouched = true;
          isPopupShown = true;
        }
        else if (element.EsType === 'S') {
          HeadId.push(element.EsId)
        }
        else {
          isAnyControlTouched = false;
        }
      }
      HeadId.forEach(element => {
        this.SubArray.value.forEach(element2 => {
          if (element == element2.EsId) {
            if (!subjectsToAlert.includes(element2.EsName)) {
              subjectsToAlert.push(element2.EsName);
            }
          }
        });
      });
    });
    console.log('subjectsToAlert', subjectsToAlert);
    console.log('isAnyControlTouched', isAnyControlTouched);
    console.log('isPopupShown', isPopupShown);

    if (subjectsToAlert.length > 0 && this.ReExam == false) {
      const data = {};
      data['message'] = `You will not be able to appear for the following subjects: ${subjectsToAlert.join(', ')}. Are you sure you want to proceed?`;
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.UpdateEditExamForms();
        }
      });
    }
    if (isAnyControlTouched == false && isPopupShown == false) {
      this.UpdateEditExamForms();
    }
  }

  fetchStudentAttd(ecid, rgid) {
    if (this.studentType == 'R') {
      this.attendance = [];
      this.SubAtd = false;
      this.SubMessage = '';
      this.fetchStudentIAAtd();
      setTimeout(() => {
        this.tryPopulateAttendance();
        this.getStudentIAElectiveStatus();
      }, 100);
      return;
    }
    
    this.spinner.show()
    const payload = {};
    this.Subjects = [];
    this.SubCode = [];
    this.EsID = [];
    this.SubAtd = false;
    this.atdstatus = false;
    this.SubMessage = ' ';
    payload['StuID'] = this.StudentPersonalId;
    payload['EmId'] = this.EmId;
    payload['SessionID'] = this.SessionNo;
    payload['CoCode'] = this.CoCode;
    
    this.umsService.StuAttendance(payload).subscribe((res) => {
      if (res.status) {
        this.attendance = res.data[0] || [];
        this.spinner.hide();
        
        console.log('Attendance data stored:', this.attendance);
        console.log('this.ReExam:', this.ReExam);
        console.log('SessionNo:', this.SessionNo);

        if (this.ReExam == false) {
          // Process attendance deficiency
          this.attendance.forEach(element => {
            if (element.AttendStatus == 'N' || element.AttendStatus == null) {
              console.log('Attendance deficient for:', element);
              this.SubCode.push(element.HeadCode)
              this.EsID.push(element.EsId);
            }
          });
          
          // Populate attendance in form
          this.SubArray = this.examForm.get('SubArray') as FormArray;
          if (this.SubArray) {
            this.SubArray.value.forEach((element, index) => {
              this.attendance.forEach(element1 => {
                if (element1.EsId == element.EsId) {
                  this.SubArray.at(index).get('Atnd').setValue(element1.AttendCount);
                }
              })
            })
          }

          this.EsID.forEach(element => {
            this.SubArray.value.forEach((element2, index) => {
              if (element2['EsId'] == element) {
                this.SubArray.at(index).get('App').setValue('N');
                this.setDescendantsToN(element2['EsId'], this.SubArray);
                const parentEsId = element2['EsParent'];
                if (parentEsId !== 0) {
                  this.SubArray.value.forEach((elParent, parentIndex) => {
                    if (elParent['EsId'] === parentEsId) {
                      this.SubArray.at(parentIndex).get('App').setValue('N');
                      const SuperParentId = elParent['EsParent']
                      if (SuperParentId != 0) {
                        this.SubArray.value.forEach((SuperParent, Index2) => {
                          if (SuperParent['EsId'] === SuperParentId) {
                            this.SubArray.at(Index2).get('App').setValue('N');
                          }
                        })
                      }
                    }
                    this.setDescendantsToN(parentEsId, this.SubArray);
                  });
                  this.SubArray.value.forEach((elChild, childIndex) => {
                    if (elChild['EsParent'] === parentEsId) {
                      this.SubArray.at(childIndex).get('App').setValue('N');
                    }
                    this.setDescendantsToN(parentEsId, this.SubArray);
                  });
                }
              }
            });
          });
          
          this.SubCode.forEach(element => {
            this.SubArray.value.forEach((element2, index) => {
              if (element2['EsType'] == 'S') {
                if (element2['Sub'] == element) {
                  this.SubArray.at(index).get('App').setValue('N');
                  this.setDescendantsToN(element2['EsId'], this.SubArray);
                }
              }
              if (element2['EsType'] == 'P') {
                this.EsID.forEach(element3 => {
                  if (element3 == element2['EsParent']) {
                    this.SubArray.at(index).get('App').setValue('N');
                    this.setDescendantsToN(element2['EsId'], this.SubArray);
                  }
                });
              }
              if (element2['EsType'] == 'P') {
                this.EsID.forEach(element3 => {
                  if (element3 == element) {
                    this.SubArray.at(index).get('App').setValue('N');
                  }
                });
              }
            });
          });
          
          if (this.attendance.find(item => item.AttendStatus === 'N')) {
            this.atdstatus = true
            this.SubAtd = true;
            this.SubMessage = "Attendance Is Less For " + this.Subjects + " Subjects"
          } else {
            this.SubAtd = false;
            this.SubMessage = ' ';
          }
        } else {
          this.SubAtd = false;
          this.SubMessage = ' ';
        }
        
        // Call IA attendance after theory attendance is processed
        this.fetchStudentIAAtd();
        setTimeout(() => {
          this.tryPopulateAttendance();
          this.getStudentIAElectiveStatus();
        }, 200);
        
      } else {
        this.spinner.hide()
        this.SubAtd = false;
        this.SubMessage = ' ';
        this.NewSemAtd(ecid, rgid);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.NewSemAtd(ecid, rgid);
    });
  }

  NewSemAtd(ecid, rgid) {
    if (this.studentType == 'R') {
      this.attendance = [];
      this.SubAtd = false;
      this.SubMessage = '';
      this.fetchStudentIAAtd();
      setTimeout(() => {
        this.tryPopulateAttendance();
        this.getStudentIAElectiveStatus(); 
      }, 100);
      return;
    }
    
    this.spinner.show()
    const payload = {};
    this.Subjects = [];
    this.SubCode = [];
    this.EsID = [];
    this.SubAtd = false;
    this.atdstatus = false;
    this.SubMessage = ' ';
    payload['StuID'] = this.StudentPersonalId;
    payload['EmId'] = this.EmId;
    payload['SessionID'] = this.SessionNo;
    payload['CoCode'] = this.CoCode
    
    this.umsService.StuAttendanceNewSem(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.attendance = res.data[0] || [];
        
        if (this.ReExam == false) {
          this.SaveDisable = false
          let attendanceData = res.data[0]
          res.data[0].forEach(element => {
            if (element.AttendStatus == 'N' || element.AttendStatus == null) {
              const isDuplicate = this.Subjects.some((item: any) => item === element.EsName);
              if (!isDuplicate) {
              }
              this.SubCode.push(element.EsCode)
              this.EsID.push(element.EsId);
            }
          });
          
          this.SubArray = this.examForm.get('SubArray') as FormArray;
          if (this.SubArray) {
            // Populate attendance values
            this.SubArray.value.forEach((element, index) => {
              this.attendance.forEach(element1 => {
                if (element1.EsId == element.EsId) {
                  this.SubArray.at(index).get('Atnd').setValue(element1.AttendCount);
                }
              })
            })
          }
          
          this.SubCode.forEach(element => {
            this.SubArray.value.forEach((element2, index) => {
              if (element2['EsType'] == 'S') {
                if (element2['Sub'] == element) {
                  this.SubArray.at(index).get('App').setValue('N');
                  this.cdr.detectChanges();
                }
              }
              if (element2['EsType'] == 'P') {
                this.EsID.forEach(element3 => {
                  if (element3 == element2['EsParent']) {
                    this.SubArray.at(index).get('App').setValue('N');
                  }
                });
              }
            });
          });

          if (res.data[0].find(item => item.AttendStatus === 'N')) {
            this.SaveDisable = false
            this.atdstatus = true
            // let data = {}
            // data['message'] = "Attendance Is Less For " + this.Subjects + " Subjects"
            // data['title'] = 'Information'
            // data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
            // this.dialogRef.afterClosed().subscribe((result) => {
            //   this.fetchStudentIAAtd();
            // });
            this.SubAtd = true;
            this.SubMessage = "Attendance Is Less For " + this.Subjects + " Subjects"
          }
          else {
            this.SaveDisable = false
            this.SubAtd = false;
            this.SubMessage = ' ';
            this.fetchStudentIAAtd();
          }
        }
        else {
          this.SubAtd = false;
          this.SubMessage = ' ';
        }
        
        setTimeout(() => {
          this.tryPopulateAttendance();
          this.getStudentIAElectiveStatus();
        }, 200);
        
      } else {
        this.spinner.hide()
        this.SubAtd = false;
        this.SubMessage = ' ';
        if (this.SkipAttendance == false) {
          let data = {}
          data['message'] = "Attendance Not Available For Subjects"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.SaveDisable = true;
        }
        this.getStudentIAElectiveStatus();
      }
    }, (ERROR: HttpErrorResponse) => {
      let payload = {};
      payload['RgId'] = rgid;
      payload['EcId'] = ecid;
      this.umsService.ExmFormReapter(payload).subscribe((res1) => {
        this.repaterSubjects = res1.data.filter((it) => it.EmId === this.MultiEmid);
        this.count = res1.count;
        if (this.repaterSubjects.length === 0) {
          if (this.SkipAttendance == false) {
            this.spinner.hide()
            if (this.ReExam == false) {
              this.SubAtd = false;
              this.SubMessage = ' ';
              let data = {}
              data['message'] = "Attendance Not Available For Subjects"
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
              this.SaveDisable = true;
            }
          }
          else if (this.SkipAttendance == true) {
            this.spinner.hide()
          }
        }
        this.getStudentIAElectiveStatus();
      });
    });
  }

  setDescendantsToN(esId: number, subArray: FormArray) {
    subArray.value.forEach((element, index) => {
      if (element['EsParent'] === esId) {
        subArray.at(index).get('App').setValue('N');
        this.setDescendantsToN(element['EsId'], subArray);
      }
    });
  }

  // UPDATED: tryPopulateAttendance with proper checks
  tryPopulateAttendance() {
    console.log('tryPopulateAttendance called');
    console.log('attendance:', this.attendance);
    console.log('IaAttendance:', this.IaAttendance);
    
    // Wait for both attendance arrays to be available
    if (this.attendance && this.attendance.length > 0) {
      this.populateAttendanceColumn();
    } else if (this.IaAttendance && this.IaAttendance.length > 0) {
      this.populateAttendanceColumn();
    } else {
      // If no attendance data, set default empty values
      const creds = this.examForm.get('SubArray') as FormArray;
      if (creds) {
        creds.controls.forEach(control => {
          control.get('Atnd')?.setValue('');
        });
      }
      console.log('No attendance data available, set empty values');
    }
  }

  // UPDATED: populateAttendanceColumn with proper merging
  populateAttendanceColumn() {
    console.log('populateAttendanceColumn called');
    const creds = this.examForm.get('SubArray') as FormArray;
    if (!creds) {
      console.log('SubArray not found');
      return;
    }

    if (this.studentType == 'R') {
      creds.controls.forEach(control => {
        control.get('Atnd')?.setValue('');
      });
      console.log('Repeater student, cleared attendance');
      return;
    }

    const attendanceMap = new Map<number, number>();
    
    // Merge theory attendance
    if (this.attendance && this.attendance.length > 0) {
      this.attendance.forEach((item) => {
        if (item.EsId) {
          attendanceMap.set(item.EsId, item.AttendCount);
        }
      });
      console.log('Theory attendance map size:', attendanceMap.size);
    }
    
    // Merge IA attendance (overwrites if same EsId)
    if (this.IaAttendance && this.IaAttendance.length > 0) {
      this.IaAttendance.forEach((item) => {
        if (item.EsId) {
          attendanceMap.set(item.EsId, item.AttendCount);
        }
      });
      console.log('After merging IA, attendance map size:', attendanceMap.size);
    }

    // Populate the form
    let populatedCount = 0;
    creds.controls.forEach((control) => {
      const esId = control.get('EsId')?.value;
      if (attendanceMap.has(esId)) {
        const attendValue = attendanceMap.get(esId);
        control.get('Atnd')?.setValue(attendValue);
        populatedCount++;
        console.log(`Set attendance for EsId ${esId}: ${attendValue}`);
      } else {
        control.get('Atnd')?.setValue('');
      }
    });
    
    console.log(`Populated attendance for ${populatedCount} subjects`);
    this.cdr.detectChanges();
  }

  fetchStudentIAAtd() {
    const payload = {};
    this.Subjects = [];
    this.HeadSub = [];
    this.IAatd = false;
    this.IAMessage = ' ';
    payload['SessionID'] = parseInt(this.SessionNo || sessionStorage.getItem('session'))
    payload['CoCode'] = this.CoCode;
    payload['StuID'] = parseInt(this.StudentPersonalId);
    payload['EmId'] = this.EmId
    
    this.umsService.getIAAtd(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.IaAttendance = res.data[0] || [];
        console.log('IA Attendance data stored:', this.IaAttendance);
        
        if (res.data[0]?.find(item => item.AttendStatus === 'N' || item.AttendStatus === null)) {
          this.IAatd = true;
          this.IAMessage = "Attendance Is Less For " + this.Subjects.join(', ')
        }
        else {
          this.IAatd = false;
          this.IAMessage = ' ';
        }
        
        // Populate attendance after IA data is available
        setTimeout(() => {
          this.tryPopulateAttendance();
          this.getStudentIAElectiveStatus();
        }, 100);
        
      } else {
        this.spinner.hide()
        let data = {}
        this.IAatd = false;
        this.IAMessage = ' ';
        data['message'] = "Attendance Not Available For Heads"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.getStudentIAElectiveStatus();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.IAatd = false;
      this.IAMessage = ' ';
      this.getStudentIAElectiveStatus();
            // this.saveExamForm()
      // let data = {}
      // data['message'] = "Attendance Not Available"
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    });
  }

  saveExamForm() {
    this.validateGeneratedExams(this.payload)
    this.spinner.show();
    this.submitpayload = this.examForm.value;
    let abcd = this.examForm.get('SubArray') as FormArray;
    let formSubjects = abcd.value;  
    let allSubjectsToSave = [...formSubjects];
    if (this.hiddenOptionalSubjects && this.hiddenOptionalSubjects.length > 0) {
      let maxSrNo = formSubjects.length > 0 ? Math.max(...formSubjects.map(s => s.SrNo)) : 0;
      this.hiddenOptionalSubjects.forEach((hiddenSub, idx) => {
        allSubjectsToSave.push({
          SrNo: maxSrNo + idx + 1,
          EsId: hiddenSub.EsId,
          App: 'N',
        });
      });
    }

    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      allSubjectsToSave.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            EcId: new FormControl(this.EcIdNew),
            RgId: new FormControl(this.RgIdNew),
            SrNo: new FormControl(element.SrNo),
            EsId: new FormControl(element.EsId),
            App: new FormControl(element.App),
            // CultDress: new FormControl(this.examForm.value['CultDress'])
          })
        )
        this.umsService.SaveExmFrm(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.SaveDisable = true
          this.getAppliTracker();
          this.getExamForm(this.EcIdNew, this.RgIdNew)
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    });
  }

  checkvalidattion(subData, i) {
    let abcd = this.examForm.get('SubArray') as FormArray;
    let payload = abcd.value;
    if (subData.value.showYN == ' ' || subData.value.showYN == null) {
      if (subData.value.EsType == 'P') {
        if (payload[i - 1].showYN == ' ' || payload[i - 1].showYN == null) {
          return true
        }
        else {
          return false
        }
      }
      else {
        return true
      }
    }
    else {
      return false;
    }

    // If no adjacent subject has data in showYN, disable the current subject

  }

  // Print() {
  //   let data = {};
  //   data['message'] = 'Select from dropdown';
  //   data['title'] = 'Information';
  //   data['icon'] = 'fas fa-box-open';
  //   this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
  //     disableClose: true,
  //     data,
  //   });
  //   this.dialogRef.afterClosed().subscribe(result => {
  //     if (result.length == 0) {
  //       this.showPopup('No Data Found For This Session')
  //     }
  //     else if (result.length > 0) {
  //       this.printAll(result[0]['SnNo'], result[0]['ShId'], result[0]['EfEmId'], result[0]['EfEmSrNo'], result[0]['EfId'], result[0]['RgId'], result[0]['SEcId'])
  //     }
  //   });
  // }
  Print() {
    let data = {
      message: 'Select from dropdown',
      title: 'Information',
      icon: 'fas fa-box-open',
      EmId: this.MultiEmid
    };
    
    this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
      disableClose: true,
      data,
    });
    
    this.dialogRef.afterClosed().subscribe(result => {
      if (!result || result.length == 0) {
        this.showPopup('No Data Found For This Session')
      }
      else if (result.length > 0) {
        this.printAll(result[0]['SnNo'], result[0]['ShId'], result[0]['EfEmId'], result[0]['EfEmSrNo'], result[0]['EfId'], result[0]['RgId'], result[0]['SEcId'])
      }
    });
  }

  showPopup(message: string) {
    let data = {}
    data['message'] = message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.redirect('home');
    })
  }

  printAll(SnNo, ShId, EfEmId, EfEmSrNo, EfId, RgId, SEcId) {
    this.resForReport;
    let payload1 = {}
    payload1['EcId'] = SEcId;
    payload1['CgCode'] = '';
    // payload1['EmId'] = EfEmId;
    // payload1['EmSrNo'] = EfEmSrNo;
    payload1['RgId'] = RgId;
    // payload1['ShId'] = ShId
    // payload1['EfId'] = EfId;
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');

    var filter: any;
    filter = {
      // no secret data for instNo
      // "LoginId": parseInt(sessionStorage.getItem('StudentPersonalId')),
      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": 99,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": sessionStorage.getItem('StudentRGID'),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": SnNo,
      "Extra1": JSON.stringify(payload1)
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('hbsreports')
  }

  searchValid() {
    this.spinner.show()
    let payload = {};
    payload['RgNo'] = sessionStorage.getItem('StudentRGID');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['Valid'] = '';
    payload['Chng'] = '';
    payload['App'] = '';
    payload['EfId'] = 0
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['Valid'] == 'X') {
          this.spinner.hide()
          this.SaveDisable = false
        }
        else if (res.data[0]['Valid'] == 'Y') {
          this.spinner.hide()
          // this.SaveDisable = true
        }
        else {
          this.spinner.hide()
        }
      } else {
        this.spinner.hide()
        this.SaveDisable = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisable = false
    });
  }

  getAppliTracker() {
    this.spinner.show()
    let payload2 = {};
    payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload2['SessionId'] = parseInt(this.SessionNo || sessionStorage.getItem('session'));
    this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.ApplicationName == "Exam Form" && element.ApplicationSubDate != '') {
            // this.SaveDisable = true
          } else {
            // this.SaveDisable = false
          }
        });
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getCourse() {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.CourseLevel = res.data[0]['CourseLevel'];
        if (this.CourseLevel == 9 || this.CourseLevel === 9) {
          this.ShowUGCert = true;
          this.examForm.get('LogBook')?.setValidators(Validators.required);
          this.examForm.get('OtherUni')?.setValidators(Validators.required);
          this.examForm.get('PosterPresent')?.setValidators(Validators.required);
          this.examForm.get('PodiumPresent')?.setValidators(Validators.required);
          this.examForm.get('PublishPaper')?.setValidators(Validators.required);
          this.examForm.get('GCPGCLP')?.setValidators(Validators.required);
          this.examForm.get('ResearchMethodology')?.setValidators(Validators.required);
          this.examForm.get('BCLSACLS')?.setValidators(Validators.required);
          this.examForm.get('NationalSeminarCert')?.setValidators(Validators.required);
          this.examForm.get('AyurvedUndertaking')?.setValidators(Validators.required);

          this.examForm.get('LogBook')?.updateValueAndValidity();
          this.examForm.get('OtherUni')?.updateValueAndValidity();
          this.examForm.get('PosterPresent')?.updateValueAndValidity();
          this.examForm.get('PodiumPresent')?.updateValueAndValidity();
          this.examForm.get('PublishPaper')?.updateValueAndValidity();
          this.examForm.get('GCPGCLP')?.updateValueAndValidity();
          this.examForm.get('ResearchMethodology')?.updateValueAndValidity();
          this.examForm.get('BCLSACLS')?.updateValueAndValidity();
          this.examForm.get('NationalSeminarCert')?.updateValueAndValidity();
          this.examForm.get('AyurvedUndertaking')?.updateValueAndValidity();
        }
        else {
          this.ShowUGCert = false;
          this.examForm.get('LogBook')?.clearValidators();
          this.examForm.get('OtherUni')?.clearValidators();
          this.examForm.get('PosterPresent')?.clearValidators();
          this.examForm.get('PodiumPresent')?.clearValidators();
          this.examForm.get('PublishPaper')?.clearValidators();
          this.examForm.get('GCPGCLP')?.clearValidators();
          this.examForm.get('ResearchMethodology')?.clearValidators();
          this.examForm.get('BCLSACLS')?.clearValidators();
          this.examForm.get('NationalSeminarCert')?.clearValidators();
          this.examForm.get('AyurvedUndertaking')?.clearValidators();

          this.examForm.get('LogBook')?.updateValueAndValidity();
          this.examForm.get('OtherUni')?.updateValueAndValidity();
          this.examForm.get('PosterPresent')?.updateValueAndValidity();
          this.examForm.get('PodiumPresent')?.updateValueAndValidity();
          this.examForm.get('PublishPaper')?.updateValueAndValidity();
          this.examForm.get('GCPGCLP')?.updateValueAndValidity();
          this.examForm.get('ResearchMethodology')?.updateValueAndValidity();
          this.examForm.get('BCLSACLS')?.updateValueAndValidity();
          this.examForm.get('NationalSeminarCert')?.updateValueAndValidity();
          this.examForm.get('AyurvedUndertaking')?.updateValueAndValidity();
        }
        if (res.data[0]['CoRgPrfx'] != "" && res.data[0]['CoRgPrfx'] != 0) {
          this.prefix = res.data[0]['CoRgPrfx'];
          this.RegnNo = this.examForm.get('RegnNo').value;
          this.formattedPrn = this.RegnNo.toString().padStart(8, '0');
        }
        else if (res.data[0]['CoRgPrfx'] == "" || res.data[0]['CoRgPrfx'] == 0) {
          this.prefix = ''
          this.RegnNo = this.examForm.get('RegnNo').value;
        }
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  transPRN(RgNo) {
    this.formattedPrn = RgNo.toString().padStart(8, '0');
  }

  OpenDoc() {

  }

  UpdateEditExamForms() {
    console.log();

    const creds = this.examForm.get('arrData') as FormArray;

    this.examForm.get('CultDress')?.markAsTouched();

    if (this.ShowUGCert) {
      this.examForm.get('LogBook')?.markAsTouched();
      this.examForm.get('OtherUni')?.markAsTouched();
      this.examForm.get('PosterPresent')?.markAsTouched();
      this.examForm.get('PodiumPresent')?.markAsTouched();
      this.examForm.get('PublishPaper')?.markAsTouched();
      this.examForm.get('GCPGCLP')?.markAsTouched();
      this.examForm.get('ResearchMethodology')?.markAsTouched();
      this.examForm.get('BCLSACLS')?.markAsTouched();
      this.examForm.get('NationalSeminarCert')?.markAsTouched();
      this.examForm.get('AyurvedUndertaking')?.markAsTouched();

      creds.controls.forEach(control => {
        control.get('DocumentFile')?.markAsTouched();
      });
    }

    if (this.examForm.invalid) {
      return;
    }
    this.spinner.show();

    let payload: any = {
      EcId: this.data['EcId'],
      RgId: this.RgId,
      Documents: [],
      CultDress: this.examForm.value['CultDress'],
      LogBook: this.examForm.value['LogBook'],
      OtherUni: this.examForm.value['OtherUni'],
      PosterPresent: this.examForm.value['PosterPresent'],
      PodiumPresent: this.examForm.value['PodiumPresent'],
      PublishPaper: this.examForm.value['PublishPaper'],
      GCPGCLP: this.examForm.value['GCPGCLP'],
      ResearchMethodology: this.examForm.value['ResearchMethodology'],
      BCLSACLS: this.examForm.value['BCLSACLS'],
      NationalSeminarCert: this.examForm.value['NationalSeminarCert'],
      AyurvedUndertaking: this.examForm.value['AyurvedUndertaking'],
    };

    this.examForm.value.arrData.forEach((element, index) => {
      payload.Documents.push({
        DocumentFile: this.fileUploads[index],
        DocumentFileName: element.DocumentName
      });
    });

    this.umsService.UpdateEditExamForms(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.saveExamForm();
      } else {
        this.showAlert(res.message);
      }
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.showAlert(error.error.message);
    });
  }

  private showAlert(message: string) {
    const data = {
      message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.value.DocumentFile
      });
  }

  getExamForm(ecid, rgid) {
    const payload = {};
    payload['EcId'] = ecid
    payload['RgId'] = rgid;
    const creds = this.examForm.controls.arrData as FormArray;
    creds.clear()
    this.umsService.getExamForm(payload).subscribe(res => {
      if (res.status) {
        this.examForm.controls['CultDress'].setValue(res.data[0]['CultDress'])
        this.examForm.controls['LogBook'].setValue(res.data[0]['LogBook'])
        this.examForm.controls['OtherUni'].setValue(res.data[0]['OtherUni'])
        this.examForm.controls['PosterPresent'].setValue(res.data[0]['PosterPresent'])
        this.examForm.controls['PodiumPresent'].setValue(res.data[0]['PodiumPresent'])
        this.examForm.controls['PublishPaper'].setValue(res.data[0]['PublishPaper'])
        this.examForm.controls['GCPGCLP'].setValue(res.data[0]['GCPGCLP'])
        this.examForm.controls['ResearchMethodology'].setValue(res.data[0]['ResearchMethodology'])
        this.examForm.controls['BCLSACLS'].setValue(res.data[0]['BCLSACLS'])
        this.examForm.controls['NationalSeminarCert'].setValue(res.data[0]['NationalSeminarCert'])
        this.examForm.controls['AyurvedUndertaking'].setValue(res.data[0]['AyurvedUndertaking'])

        if (res.data[0]['DocumentFile']) {
          this.DocView = true;
          res.data.forEach(element => {
            creds.push(
              this.fb.group({
                DocumentName: new FormControl(element.DocumentName),
                DocumentFile: new FormControl(element.DocumentFile),
                docFile: new FormControl(element.DocumentFile),
              })
            );
          });
        }
        else {
          creds.push(
            this.fb.group({
              DocumentName: new FormControl('Attendance Certificate Of Research Methodology Workshop'),
              DocumentFile: new FormControl(''),
              docFile: new FormControl(''),
            })
          );
        }


      }
      else {

      }
    })
  }

  fileUploads: string[] = [];
  onChange($event: Event, rowIndex: number) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    const faControl = (<FormArray>this.examForm.controls['arrData']).at(rowIndex);

    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (ext === "pdf") {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        let data = {
          message: 'Please Upload Only PDF File',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }

  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      while (this.fileUploads.length <= rowIndex) {
        this.fileUploads.push(null);
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.examForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);
    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  // Document management methods
  addPosterPresCerti() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'Poster presentation at a National/Zonal/State conference';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('Poster presentation at a National/Zonal/State conference'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removePosterPresCerti() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'Poster presentation at a National/Zonal/State conference') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addPodiumPresCerti() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'Podium presentation at a National/Zonal/State conference';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('Podium presentation at a National/Zonal/State conference'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removePodiumPresCerti() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'Podium presentation at a National/Zonal/State conference') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addPaperPresentation() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'Have one research paper published/accepted for publication in journal of his/her speciality as first author';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('Have one research paper published/accepted for publication in journal of his/her speciality as first author'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removePaperPresentation() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'Podium presentation at a National/Zonal/State conference') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addGCP() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'GCP and GCLP (whichever is relevant) - conducted by institute';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('GCP and GCLP (whichever is relevant) - conducted by institute'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeGCP() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'GCP and GCLP (whichever is relevant) - conducted by institute') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addRMethodology() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'Research Methodology / Online BCBR';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('Research Methodology / Online BCBR'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeRMethodology() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'Research Methodology / Online BCBR') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addBCLS() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'BCLS and ACLS - conducted by institute';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('BCLS and ACLS - conducted by institute'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeBCLS() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'BCLS and ACLS - conducted by institute') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addNationalSeminarCert() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'National/International seminar certificate';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('National/International seminar certificate'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeNationalSeminarCert() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'National/International seminar certificate') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }

  addAyurvedUndertaking() {
    const creds = this.examForm.controls.arrData as FormArray;
    const isDuplicate = creds.controls.some((group: AbstractControl) => {
      return group.get('DocumentName')?.value === 'Undertaking for Ayurved';
    });
    if (!isDuplicate) {
      creds.push(
        this.fb.group({
          DocumentName: new FormControl('Undertaking for Ayurved'),
          DocumentFile: new FormControl('', Validators.required),
          docFile: new FormControl(''),
        })
      );
    }
  }

  removeAyurvedUndertaking() {
    const creds = this.examForm.controls.arrData as FormArray;
    creds.value.forEach((element, index) => {
      if (element.DocumentName == 'Undertaking for Ayurved') {
        (<FormArray>this.examForm.get("arrData")).removeAt(index);
      }
    });
  }
}